import React from 'react';
import { motion } from 'framer-motion';
import { RADIUS } from '../../../config/designTokens';
import { RARITY_CONFIG } from '../../../mascot/achievements/achievementData';
import { GoldenShimmer, LegendaryGlow } from './effects';
import { useAchievementShimmer } from './useAchievementShimmer';
import { AchievementProgressBar } from './AchievementProgressBar';
import type { AchievementCardProps } from './types';
export function CompactAchievementCard({
  achievement,
  isUnlocked,
  index,
  showEffects
}: AchievementCardProps & {
  showEffects: boolean;
}) {
  const isNewlySeen = useAchievementShimmer(achievement.id, isUnlocked);
  const config = RARITY_CONFIG[achievement.rarity];
  const isHighlightRarity = achievement.rarity === 'rare' || achievement.rarity === 'legendary';
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    delay: index * 0.1
  }} className={`relative flex items-center gap-3 p-3 ${RADIUS.card} border-2 transition-all ${isUnlocked ? `${config.cardBg} ${config.cardBorder} ${showEffects && isHighlightRarity ? `shadow-md ${config.glowColor}` : 'shadow-sm'}` : 'bg-slate-50 border-slate-200 opacity-80'} ${isNewlySeen ? 'animate-shine' : ''}`} style={isNewlySeen ? {
    animationIterationCount: 1
  } : undefined} data-id="element-1862" data-mp="1wkn8qvzkihq1">
      
      {isUnlocked && showEffects && achievement.rarity === 'legendary' && <LegendaryGlow data-id="element-1863" data-mp="2inlnqe6ym9k3" />}
      {isUnlocked && showEffects && achievement.rarity === 'rare' && <GoldenShimmer data-id="element-1864" data-mp="2nlwycr52wo3d" />}

      <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white/50 rounded-xl" data-id="element-1865" data-mp="2nn82is2frxv0">
        <span className="text-2xl" data-id="element-1866" data-mp="2sk87eznjuukj">{achievement.emoji}</span>
      </div>

      <div className="flex-1 min-w-0" data-id="element-1867" data-mp="2xkvy1k7v99e8">
        <div className="flex items-center justify-between gap-2 mb-1" data-id="element-1868" data-mp="2xlxnitpmpyfh">
          <h4 className={`font-bold text-sm truncate ${isUnlocked ? 'text-slate-800' : 'text-slate-600'}`} data-id="element-1869" data-mp="7vtx4oo48kk0">
            
            {achievement.name}
          </h4>
          {isUnlocked && isHighlightRarity && <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-[9px] font-bold ${config.badgeBg} ${config.badgeText}`} data-id="element-1870" data-mp="28wgy9wx2hk33">
            
              {config.label}
            </span>}
        </div>

        {!isUnlocked && achievement.progress ? <AchievementProgressBar current={achievement.progress.current} max={achievement.progress.max} label={achievement.description} data-id="element-1871" data-mp="2hvuauyghmos1" /> : <p className={`text-xs truncate ${isUnlocked ? config.textColor : 'text-slate-500'}`} data-id="element-1872" data-mp="1q6isxoknm535">
          
            {achievement.description}
          </p>}
      </div>
    </motion.div>;
}